import styled from 'styled-components';
import {
  GRAY_LIGHTER,
  FONT_SIZE_7,
  GRAY_DARKER,
  FONT_WEIGHT_NORMAL,
  GRAY_LIGHT_ONE,
} from '../../../styles/variables';
import { flexPosition, fontStyle } from '../../../styles/mixins';

export const Text = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_NORMAL)}
`;

export const Content = styled.div`
  padding: 0px 10px;
`;

export const ItemContainer = styled.div`
  ${flexPosition({ align: 'center' })}
  justify-content: ${({ leftCheckbox }) => (leftCheckbox ? 'start' : 'space-between')};
  padding: 15px;
  border-bottom: 1px solid;
  border-color: ${({ selectAll }) => (selectAll ? GRAY_LIGHT_ONE : GRAY_LIGHTER)};
  height: 50px;
  background-color: ${({ selectAll }) => (selectAll ? GRAY_LIGHT_ONE : 'inherit')};
  span {
    font-weight: ${({ selectAll }) => (selectAll ? '600' : 'normal')};
  }
`;



// WEBPACK FOOTER //
// ./src/components/GenericSelectList/Item/style.js